import Player from '@vimeo/player';

export let activateSurvey = () => {
  const iframe = $('iframe')[0];
  const player = new Player(iframe);
  const status = $('.webinar-container').data('status')

  player.on('ended', function(data) {
    if (status != 'late'){
      $('#webinar-survey').modal('toggle')
    }
  });
};

export let submitSurveyHandler = () => {
  $('#submit_survey').on('click', () => {
    $('#webinar-survey').modal('toggle')
  });
};
